import { pgTable, uuid, text, timestamp, boolean, index } from "drizzle-orm/pg-core";
import { organisations } from "./organisations";
import { relations } from "drizzle-orm";
export const users = pgTable("users", {
    id: uuid("id").primaryKey().defaultRandom(),
    firstName: text("first_name"),
    lastName: text("last_name"),
    middleName: text("middle_name"),
    email: text("email").unique(),
    role: text("role"),
    timezone: text("timezone"),
    locale: text("locale"),
    organisationId: uuid("organisation_id").references(() => organisations.id),
    isAdmin: boolean("is_admin").default(false),
    createdAt: timestamp("created_at", { withTimezone: true }).defaultNow().notNull(),
    lastUpdatedAt: timestamp("updated_at", { withTimezone: true })
        .defaultNow()
        .notNull()
        .$onUpdate(() => new Date()),
    externalId: text("external_id"),
    invitedAt: timestamp("invited_at", { withTimezone: true }),
    inviteAcceptedAt: timestamp("invite_accepted_at", { withTimezone: true }),
    acceptedTosAt: timestamp("accepted_tos_at", { withTimezone: true }),
    acceptedPrivacyAt: timestamp("accepted_privacy_at", { withTimezone: true }),
}, table => ({
    emailIdx: index("email_idx").on(table.email),
}));
export const usersRelations = relations(users, ({ one }) => ({
    organisation: one(organisations, {
        fields: [users.organisationId],
        references: [organisations.id],
    }),
}));
